import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import Page from "@/components/Page";
import OrganisationCheckout from "@/components/organisations/checkout/OrganisationCheckout";
import OrganisationOrders from "@/components/organisations/orders";
import OrganisationViewOrder from "@/components/organisations/orders/OrganisationViewOrder";
import { ERROR_404_URL } from "@/core/urls";
import DashboardSwitcher from "@/tpo/DashboardSwitcher";
import PartnerRoute from "@/tpo/PartnerRoute";

import CmpHomeDashboard from "./CmpHomeDashboard";
import OrganisationTab from "./business";
import OrganisationCommissions from "./comissions/OrganisationCommissions";
import {
  CMP_PERMISSION_ADMIN,
  CMP_PERMISSION_PLACE_ORDERS,
  CMP_PERMISSION_VIEW_COMMISSIONS,
  CMP_PERMISSION_VIEW_ORDERS,
  CMP_PERMISSION_VIEW_RESULTS,
  CMP_PERMISSION_VIEW_SHOP,
  CMP_PERMISSION_VIEW_SUPPORT
} from "./constants";
import KnowledgeBase from "./learningHub";
import OrganisationPatients from "./patients";
import PractitionerProfile from "./profile/PractitionerProfile";
import OrganisationShop from "./shop/OrganisationShop";
import Support from "./support/Support";

export default function OrganisationDashboard() {
  const match = useRouteMatch();

  return (
    <Switch>
      <PartnerRoute permissionsRequired={[]} exact path={match.path}>
        <Page bg="haze" includeFooter addNavBarHeight={false}>
          <DashboardSwitcher bg="partners" isPartnerPage />
          <CmpHomeDashboard />
        </Page>
      </PartnerRoute>
      <PartnerRoute permissionsRequired={[]} exact path={`${match.path}/profile`}>
        <Page bg="haze" includeFooter addNavBarHeight={false}>
          <DashboardSwitcher bg="partners" isPartnerPage title="Profile" />
          <PractitionerProfile />
        </Page>
      </PartnerRoute>
      <PartnerRoute permissionsRequired={[CMP_PERMISSION_ADMIN]} path={`${match.path}/business`}>
        <Page bg="haze" includeFooter addNavBarHeight={false}>
          <DashboardSwitcher bg="partners" isPartnerPage title="Organisation" />
          <OrganisationTab />
        </Page>
      </PartnerRoute>
      <PartnerRoute
        permissionsRequired={[CMP_PERMISSION_VIEW_RESULTS]}
        path={`${match.path}/patients`}
      >
        <Page bg="haze" includeFooter addNavBarHeight={false}>
          <DashboardSwitcher bg="partners" isPartnerPage title="Patients" />
          <OrganisationPatients />
        </Page>
      </PartnerRoute>
      <PartnerRoute
        permissionsRequired={[CMP_PERMISSION_VIEW_COMMISSIONS]}
        exact
        path={`${match.path}/commissions`}
      >
        <Page bg="haze" includeFooter addNavBarHeight={false}>
          <DashboardSwitcher bg="partners" isPartnerPage title="Commissions" />
          <OrganisationCommissions />
        </Page>
      </PartnerRoute>
      <Redirect from={`${match.path}/affiliate_links`} to={match.url} />
      <PartnerRoute
        permissionsRequired={[CMP_PERMISSION_PLACE_ORDERS]}
        exact
        path={`${match.path}/checkout`}
      >
        <Page bg="haze" includeFooter addNavBarHeight={false}>
          <DashboardSwitcher bg="partners" isPartnerPage title="Checkout" />
          <OrganisationCheckout />
        </Page>
      </PartnerRoute>
      <PartnerRoute
        exact
        permissionsRequired={[CMP_PERMISSION_VIEW_SUPPORT]}
        path={`${match.path}/support`}
      >
        <Page bg="haze" includeFooter addNavBarHeight={false}>
          <DashboardSwitcher bg="partners" isPartnerPage title="Support" />
          <Support />
        </Page>
      </PartnerRoute>
      <PartnerRoute
        permissionsRequired={[CMP_PERMISSION_VIEW_SHOP, CMP_PERMISSION_PLACE_ORDERS]}
        path={`${match.path}/shop`}
      >
        <Page bg="haze" includeFooter addNavBarHeight={false}>
          <DashboardSwitcher bg="partners" isPartnerPage title="Shop" />
          <OrganisationShop />
        </Page>
      </PartnerRoute>
      <PartnerRoute
        permissionsRequired={[CMP_PERMISSION_VIEW_ORDERS]}
        path={`${match.path}/order/:orderId`}
        exact
      >
        <Page bg="haze" includeFooter addNavBarHeight={false}>
          <DashboardSwitcher bg="partners" isPartnerPage title="Order" />
          <OrganisationViewOrder />
        </Page>
      </PartnerRoute>
      <PartnerRoute
        permissionsRequired={[CMP_PERMISSION_VIEW_ORDERS]}
        path={`${match.path}/orders`}
      >
        <Page bg="haze" includeFooter addNavBarHeight={false}>
          <DashboardSwitcher bg="partners" isPartnerPage title="Orders" />
          <OrganisationOrders />
        </Page>
      </PartnerRoute>
      <PartnerRoute
        permissionsRequired={[]}
        path={`${match.path}/learning_hub`}
        component={KnowledgeBase}
      />
      <Redirect to={ERROR_404_URL} />
    </Switch>
  );
}
